module.exports = __webpack_public_path__ + "static/media/ADMINISTRACIONDINERO27QueEsElGasto.8d6b8e6.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videos/ADMINISTRACIONDINERO27QueEsElGasto.mp4
// module id = 753
// module chunks = 1